// extracted by mini-css-extract-plugin
module.exports = {"screenreaderonly":"_1SMXab","clearfix":"_2LS2jU","text":"_2wzXUU","av-hover":"NkAvpV"};